type ScrollPosition = Pick<Element, 'scrollTop' | 'scrollHeight' | 'clientHeight'>

/**
 * 右の「指定なし」一覧が縦にスクロールしたとき、表（客室の一覧）を同じ位置へ合わせるかを返す。
 * 一覧が一番下で止まり表がそれより下にあるのは、表に合わせた一覧がそれ以上動けなかったときなので、表を引き戻さない。
 */
export const shouldRoomsFollowUnattachedRooms = (roomsScrollTop: number, unattachedRooms: ScrollPosition): boolean => {
  // 画面の拡大率によって scrollTop は端数になり、一番下でも scrollHeight - clientHeight と一致しないことがある
  const isUnattachedRoomsAtBottom = unattachedRooms.scrollHeight - unattachedRooms.clientHeight - unattachedRooms.scrollTop <= 1
  return !(isUnattachedRoomsAtBottom && roomsScrollTop > unattachedRooms.scrollTop)
}
